module.exports = __webpack_public_path__ + "static/logo-red-862be5457bc49ec26e1b43618df27ba9.png";